import { reportColumnAggregateTypesEnum } from "helpers/enums";
import { load, store } from "helpers/filtersStorage";
import { paths } from "helpers/paths";
import { DefaultColumnFilter, reportFilterWrapper } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import { matchSorter } from "match-sorter";
import Tooltip from "rc-tooltip";
import React, { Component, Fragment } from "react";
import { defaultColumnWidth } from "./config";
import Table from "./table";

export default class CommonReport extends Component {
    state = {
        filters: [],
        expanded: [],
        sortBy: [],
        tableDefaultProps: { columns: [] },
    };

    componentDidMount() {
        this.setState({ tableDefaultProps: this.tableDefaultProps() });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dataLoadedAt !== this.props.dataLoadedAt) {
            this.setState({ tableDefaultProps: this.tableDefaultProps() });
        }
    }

    numericClrTypes = ["double", "int64"];

    idColumn = {
        Header: "#",
        id: "row",
        filterable: false,
        Cell: ({ row }) => <div>{row.index + 1}</div>,
    };

    footerVal = (column) => {
        if (!column) {
            return "";
        }
        const { footer } = this.props.data || {};
        const value = footer[columnName(column)];
        const { clrType, aggregateType } = column;
        if (!aggregateType || aggregateType === reportColumnAggregateTypesEnum.None) {
            return null;
        }
        return <span>{aggregateType ? formatValue(value, clrType) : ""}</span>;
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        return [this.idColumn].concat(columns.map(this.cellProps));
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            show: !column.isAdditionalColumn,
            Cell: (props) => {
                switch (props.column.id) {
                    case "bids":
                        return (props.value || []).map(({ id, hasManualMileage }, index) => (
                            <Fragment key={index}>
                                <a
                                    data-bidid={id}
                                    href={paths.bidShow("bid", id)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {id}
                                </a>
                                {hasManualMileage && (
                                    <>
                                        &nbsp;
                                        <Tooltip overlay="Закрыта вручную">
                                            <span className="icon-uEA83-user-edit b-point__tooltip-icon" />
                                        </Tooltip>
                                    </>
                                )}
                                <br />
                            </Fragment>
                        ));
                    case "bidIds":
                        return (props.value || "").split(", ").map((bidId, index) => (
                            <Fragment key={index}>
                                <a
                                    data-bidid={bidId}
                                    href={paths.bidShow("bid", bidId)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {bidId}
                                </a>
                                <br />
                            </Fragment>
                        ));
                    case "bidId":
                        return (
                            <a
                                data-bidid={props.value}
                                href={paths.bidShow("bid", props.value)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {props.value}
                            </a>
                        );
                    default:
                        return <div className="long-text">{formatValue(props.value, column.clrType)}</div>;
                }
            },
            Footer: () => this.footerVal(column),
            ...typeSpecificProps(column),
        };
    };

    tableExtraProps = () => ({});

    tableDefaultProps = () => ({
        id: this.props.id,
        defaultColumn: {
            Filter: reportFilterWrapper(DefaultColumnFilter),
            filterable: true,
            filter: (rows, _id, filterValue) => {
                if (!filterValue || !filterValue.value) {
                    return rows;
                }
                return rows.filter(
                    (row) =>
                        matchSorter([row.values[filterValue.id]], filterValue.value, {
                            threshold: matchSorter.rankings.CONTAINS,
                        }).length !== 0,
                );
            },
            Footer: () => "",
        },
        columns: this.extractColumns(),
        noDataText: "Нет данных для отображения",
        loadingText: "Загрузка...",
    });

    setTableState = (data) => this.setState(data);

    underTableData = () => this.footerAdditionalInfo();

    footerAdditionalInfo = () => {
        const { data } = this.props;
        if (!data.footerAdditionalInfo) {
            return null;
        }
        return (
            <div className="card card-body flex-grow-0 px-0 py-1 mt-3 w-fit-content">
                <table className="table table-xs mb-0">
                    <tbody>
                        <tr>
                            <td className="noborder font-weight-bold">Итого</td>
                            <td className="noborder" />
                        </tr>
                        {data.footerAdditionalInfo.columns.map(({ label, propertyName, clrType }) => (
                            <tr key={propertyName}>
                                <td className="font-weight-bold">{label}</td>
                                <td className="text-right">
                                    {formatValue(data.footerAdditionalInfo.data[columnName({ propertyName })], clrType)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    render() {
        const { data, localFilterData } = this.props;
        const resultData = localFilterData || data.data;
        const columnWidths = load(`${this.props.id}Widths`, {});
        const { columns, ...tableDefaultProps } = this.state.tableDefaultProps;
        const columnsWithWidth = columns.map((column) => ({
            ...column,
            width:
                column.width ||
                columnWidths[column.accessor || column.id] ||
                defaultColumnWidth(column.accessor || column.id),
        }));
        const tableState =
            this.props.isPrintForm && this.props.printTableState ? this.props.printTableState : this.state;
        const props = {
            ...tableDefaultProps,
            filterProps: {
                storeColumnWidth: ({ columnWidths }) => {
                    const currentValues = load(`${this.props.id}Widths`, {});
                    store(`${this.props.id}Widths`, { ...currentValues, ...columnWidths });
                },
                tableState,
                setTableState: this.setTableState,
                setPrintTableState: this.props.setPrintTableState,
            },
            data: resultData,
            modal: this.props.modal,
            columns: columnsWithWidth,
            isPrintForm: this.props.isPrintForm,
            withoutPagination: this.props.withoutPagination,
            onPaginationInfoChange: this.props.onPaginationInfoChange,
            ...this.tableExtraProps(),
        };
        return (
            <>
                {this.props.isPrintForm && <h5>{data.name}</h5>}
                <Table isNotExportable {...props} />
                {this.underTableData()}
            </>
        );
    }
}
